import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { formatPrice } from 'type/Item'

export const ItemTitle = observer(() => {
  const demo = useDemo()
  const { stand, show_name } = demo
  const { prices } = demo.product.details ?? {}
  const { item } = itemPreview.it
  const { product_name } = item
  const price = formatPrice(item.prices)
  const font = stand ? 32 : 17

  return (
    <Vertical gap={4}>
      <Typo size={font} medium upper>
        {show_name ? product_name : i18n('Item')}
      </Typo>
      {prices && price && (
        <Typo size={font} medium primary>
          {price}
        </Typo>
      )}
    </Vertical>
  )
})
